import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { withTranslation } from "react-i18next";

import getChartData from "utils/getChartData";
import { chartColors } from "common/constant";

const ActiveTariffChart = ({ tariffWiseActiveInactiveConsumers, t }) => {
  const initialOption = {
    chart: {
      height: 350,
      type: "bar",
      stacked: true,
    },
    dataLabels: {
      enabled: true,
    },
    xaxis: {
      categories: [],
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        borderRadiusApplication: "end", // 'around', 'end'
        borderRadiusWhenStacked: "last", // 'all', 'last'
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },
    legend: {
      onItemHover: {
        highlightDataSeries: false,
      },
      formatter: (seriesName, opts) => {
        const total = opts.w.globals.series[opts.seriesIndex].reduce(
          (acc, curr) => acc + curr,
          0
        );
        return [seriesName, " - ", total];
      },
    },
    colors: chartColors,
  };
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState(initialOption);
  const [consumerType, setConsumerType] = useState("activated");

  useEffect(() => {
    if (tariffWiseActiveInactiveConsumers) {
      const { barChartData, barChartLabels } = getChartData(
        tariffWiseActiveInactiveConsumers,
        "utilityConsumerTariffActivatedAndDisconnected",
        "tariffName",
        consumerType,
        "month"
      );
      const seriesData = Object.entries(barChartData).map(([key, value]) => ({
        name: key,
        data: value,
      }));

      setSeries(seriesData);
      setOptions((prev) => ({
        ...prev,
        xaxis: { ...prev.xaxis, categories: barChartLabels },
      }));
    }
  }, [tariffWiseActiveInactiveConsumers, consumerType]);

  return (
    <Card className="p-0">
      <CardHeader
        title={
          <Grid container>
            <Grid item xs={8}>
              <Typography variant="subtitle1" fontWeight={700}>
                {t("Tariff Consumer")}
              </Typography>
            </Grid>
            <Grid item xs={4} className="text-end">
              <Button
                variant={consumerType === "activated" ? "contained" : "text"}
                className="me-1"
                size="small"
                onClick={() => {
                  setConsumerType("activated");
                }}
              >
                {t("Active")}
              </Button>
              <Button
                variant={consumerType !== "activated" ? "contained" : "text"}
                size="small"
                onClick={() => {
                  setConsumerType("disconnected");
                }}
              >
                {t("InActive")}
              </Button>
            </Grid>
          </Grid>
        }
        className="border-bottom"
      />
      <CardContent>
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={450}
        />
      </CardContent>
    </Card>
  );
};

ActiveTariffChart.propTypes = {
  tariffWiseActiveInactiveConsumers: PropTypes.array,
  t: PropTypes.func,
};

export default withTranslation()(ActiveTariffChart);
